<template>
    <v-snackbar :class="`snackbar-base border-${props.color}`" @click.native="clicked()" v-model="props.visible" :bottom="props.bottom"  :left="props.left" :multi-line="props.multiline" :right="props.right" :timeout="props.timeout" :top="props.top" :vertical="props.vertical" transition="scale-transition">
        <v-row justify="space-between" align="center" class="" >
            <span class="font-weight-bold black--text" v-if="props.title">{{props.title}}</span>
            <div class="black--text " v-html="props.text"></div>
            
        </v-row>


    </v-snackbar>
   
</template>
<script>
    export default {
        name: 'snackbar',
        props: ['props'],
        model: {
           
            event: 'click'
        },
        computed: {
            timeout(){
                return this.props.timeout == 0 ? "-1" : this.props.timeout
            }
        },
        methods:{
            clicked()
            {
                this.props.visible = false;
                this.$emit('click');
            },


        }
    }
</script>

<style lang="scss">
    .snackbar-base > .white{
       border-color: unset !important;
    }
    .snackbar-base .v-sheet.v-snack__wrapper{
        background-color: white;
        padding: 10px 10px 10px 10px;
       
        border-left-width: 10px !important;
        border-left-style: outset !important;
    }
    .border-success .v-sheet.v-snack__wrapper{
        border-left-color: #6cc822 !important;
    }
    .border-error .v-sheet.v-snack__wrapper{
        border-left-color: #de0000 !important;
    }
    .border-info .v-sheet.v-snack__wrapper{
        border-left-color: #2196F3 !important;
    }
</style>